<b2c-header></b2c-header>

<main>
  <router-outlet></router-outlet>
</main>

<b2c-footer></b2c-footer>

<login-request-dialog
  #loginRequestDialog
></login-request-dialog>
